export default __webpack_public_path__ + "static/media/final.f5ea070a.png";